import React from 'react';
import './Spinner.css';

const Spinner = () => (
    <div className="r4r-cts-spinner">
        <div className="spinkit spinner">
            <div className="dot1"></div>
            <div className="dot2"></div>
        </div>
    </div>
)

export default Spinner;